<template>
  <div class="bookmaster-wraper">
    <app-modal-confirm
      ref="apikey_modal_delete"
      :modal-header-title="$t('common_vn.delete confirm title')"
      @confirmed="deleteApiKey()"
    >
      <template v-slot:body>
        <p class="confirm-body">{{ $t("common_vn.delete confirm") }}</p>
      </template>
    </app-modal-confirm>

    <app-modal-confirm
      ref="restaurant_modal_delete"
      :modal-header-title="$t('common_vn.delete confirm title')"
      @confirmed="deleteRestaurant()"
    >
      <template v-slot:body>
        <p class="confirm-body">{{ $t("common_vn.delete confirm") }}</p>
      </template>
    </app-modal-confirm>

    <validation-observer
      ref="form_create_entry"
      v-slot="{ passes, valid, validated }"
    >

      <form class="form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card card-body">
              <template v-if="idEditing">
                <div class="form-group row">
                  <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("common.id") }}</label>
                  <label class="col-xl-1 col-lg-2 col-sm-2 m-t-8">{{ entry.id }}</label>
                </div>
              </template>

              <!-- category name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("table_order.customer_name") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-input
                    name="kyy_table_order_customer_name"
                    type="string128"
                    rules="required"
                    v-model="entry.name"
                  />
                </div>
              </div>
              <!-- Restaurant name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("restaurant.name") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-select
                    name="restaurant_name"
                    rules="required"
                    :options-data="restaurantList"
                    v-model="entry.restaurant_id"
                  />
                </div>
              </div>

              <!-- table_order name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("table_order.order_time") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-date-range-picker
                    name="kyy_table_order_order_time"
                    v-model="entry.date"
                    timePicker="true"
                    rules="required"
                    format="YYYY-MM-DD H:mm"
                    @input="entry.date = $event"
                    :minDate="moment().format('YYYY-MM-DD HH:mm')"
                  />
                </div>
              </div>

              <!-- table_order name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("table_order.guest_number") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-input
                    name="kyy_table_order_guest_number"
                    type="number-length:2"
                    rules="required|min_value:1|max_value:30"
                    v-model="entry.guest_number"
                  />
                </div>
              </div>

              <!-- table_order name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("table_order.phone_number") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-input
                    name="kyy_table_order_phone_number"
                    type="digits"
                    rules="required|phone_number"
                    v-model="entry.phone_number"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">Phòng riêng</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-checkbox
                    name="kyy_table_order_specials_private_room_input"
                    v-model="entry.specials.private_room_input"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">Phòng Bar</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-checkbox
                    name="kyy_table_order_specials_bar_input"
                    v-model="entry.specials.bar_input"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">Ghế cho trẻ nhỏ</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-checkbox
                    name="kyy_table_order_specials_chair_input"
                    v-model="entry.specials.chair_input"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">Có dị ứng</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-checkbox
                    name="kyy_table_order_customer_allergy"
                    v-model="entry.customer_allergy"
                  />
                </div>
              </div>

              <!-- table_order name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">Chi tiết dị ứng</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-textarea
                    name="kyy_table_order_customer_allergy_detail"
                    type="string128"
                    v-model="entry.customer_allergy_detail"
                  />
                </div>
              </div>

              <!-- table_order name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("table_order.status") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-select
                    name="kyy_table_order_status"
                    rules="required"
                    :options-data="TABLE_ORDER_CONSTANT.STATUS_ORDER"
                    v-model="entry.status"
                  />
                </div>
              </div>

              <!-- Restaurant name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.name") }}
                </label>
                <div class="col-xl-5 col-lg-6 col-sm-6">
                  <app-select-multi
                    name="kyy_category_menu_ids"
                    :options-data="categoryMenuList"
                    v-model="entry.category_menu_ids"
                  />
                  <div class="note">
                    <p class="m-0 p-0 note-item text-danger" v-for="(item, index) in noteUpdate" :key="index">
                      {{ item }} {{ $t("table_order.has_changes") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- table_order name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("table_order.note") }} </label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-textarea
                    name="kyy_table_order_note"
                    type="string128"
                    v-model="entry.note"
                  />
                </div>
              </div>


              <div class="card-footer row justify-content-end">
                <button type="button" :disabled="!valid && validated" class="btn btn-default m-r-10" @click="confirmCancel">
                  {{ $t('common_vn.cancel') }}
                </button>
                <button v-if="idEditing" type="button" :disabled="!valid && validated" class="btn btn-danger m-r-10" @click="handleDelete">
                  {{ $t('common_vn.delete') }}
                </button>
                <button v-if="idEditing" :disabled="!valid && validated" class="btn btn-primary m-r-10" @click="createOrUpdate" type="button">
                  {{  $t('common_vn.save') }}
                </button>
                <button v-else :disabled="!valid && validated" class="btn btn-primary m-r-10" type="button" @click="createOrUpdate" >
                  {{  $t('common_vn.create') }}
                </button>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import AppTextarea from "../../../components/forms/AppTextarea";
import AppDateRangePicker from "../../../components/forms/AppDateRangepicker";
import {ROUTES} from "@constants";
import AppCheckbox from "../../../components/forms/AppCheckbox";
export default {
  name: "CategoryCreateOrEdit",

  components: {
    AppCheckbox,
    AppTextarea,
    AppDateRangePicker,
  },

  data() {
    const id = this.$route.params.id
    return {
      entry: {
        id: null,
        name: '',
        order_time: moment().format('YYYY-MM-DD HH:mm'),
        phone_number: '',
        status: 1,
        guest_number: '',
        note: '',
        data_updated_at: null,
        restaurant_id: null,
        category_menu_ids: [],
      },
      noteUpdate: [],
      restaurantList: [],
      categoryMenuList: [],
      apiKeyId: null,
      idEditing: id,
      entryNameUpdate: "",
      startValidate : !!id,
      allowedExtension : ['image/jpeg', 'image/png', 'image/jpg']
    };
  },
  watch: {
    "entry.restaurant_id": async function (value) {
      if (value) {
        let filters = {
          'restaurant_id': value
        }

        let responseForCategory = await this.$request.get(this.ENDPOINT.KYY_TABLE_ORDER_GET_CATEGORY_MENU, filters);
        if (responseForCategory.hasErrors()) {
          if (responseForCategory.status === 'error'){
            this.__noticeError(this.$t(responseForCategory.data.error_msg));
          }
          this.categoryMenuList = [];
          this.entry.category_menu_ids = null;
        } else {
          this.categoryMenuList = responseForCategory.data.map(item => {
            return {
              id: item.id,
              name: item.name
            }
          });
          if (!this.startValidate) {
            this.entry.category_menu_ids = null;
          }
        }
      }
    },
  },

  mounted: async function () {
    // call api get list restaurant
    let response = await this.$request.get(this.ENDPOINT.KYY_RESTAURANT_LIST_SELECT);
    if (response.hasErrors()) {
      if (response.status === 'error'){
        this.__noticeError(this.$t(response.data.error_msg));
      }
    } else {
      this.restaurantList = response.data.data.map(item => {
        return {
          id: item.id,
          name: item.name
        }
      });
    }
    if (this.idEditing) {
      this.startValidate = false;
      let response = await this.$request.get(this.ENDPOINT.KYY_TABLE_ORDER_EDIT(this.idEditing));
      if (response.hasErrors()) {
        if (response.status === 'error') {
          this.__noticeError(this.$t(response.data.error_msg));
        }
        await this.redirectDefaultValue()
      } else {
        this.entry = _.cloneDeep(response.data.data);
        this.entry.category_menu_ids = this.entry.tableOrderItem.map((item) => {
          if (item.category_menu_with_trashed.deleted_at) {
            this.noteUpdate.push(item.category_menu_with_trashed.name);
          }
          return item.kyy_category_menu_id;
        });
        this.startValidate = true;
      }
    }
  },

  methods: {
    confirmCancel()
    {
      if(this.$store.state.setting.prevRouter.name === ROUTES.ADMIN.BOOK_MASTER_LIST) {
        this.__redirectBack()
      } else {
        this.redirectDefaultValue()
      }
    },
    async createOrUpdate() {
      this.startValidate = true;
      if (!await this.$refs.form_create_entry.validate()) {
        return;
      }
      let res = null;
      let msg = "";
      let params = _.cloneDeep(this.entry);
      if (this.idEditing) {
        res = await this.$request.patch(this.ENDPOINT.KYY_TABLE_ORDER_EDIT(this.idEditing), params);
        msg = this.$t("common.msg update ok")
      } else {
        res = await this.$request.post(this.ENDPOINT.KYY_TABLE_ORDER_CREATE, params);
        msg = this.$t("common.msg create ok")
      }
      if (res.hasErrors()) {
        this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
      } else {
        this.__noticeSuccess(msg);
        await this.redirectDefaultValue();
      }
    },

    async redirectDefaultValue() {
      await this.$router.push({
        name: this.ROUTES.ADMIN.KYY_TABLE_ORDER_LIST, query: {}
      });
    },
    handleDelete() {
      this.$refs.restaurant_modal_delete.show();
    },
    async deleteRestaurant() {
      const res = await this.$request.delete(this.ENDPOINT.KYY_TABLE_ORDER_DELETE(this.idEditing));
      if (!res.hasErrors()) {
        this.__noticeSuccess(this.$t("common.msg delete ok"));
        await this.redirectDefaultValue();
      } else {
        this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
        this.$refs.restaurant_modal_delete.hide();
      }
    },
  },
};
</script>
<style>
@media (min-width: 1200px) {
  .col-unit {
    flex: 0 0 14%;
  }
}

</style>
